/**
 * 系统icon的匹配转换抽离
 * author:brian
 * date:2022 06 02
 */

import { carrierIcon, deviceTypeIcon } from './icon.js';

// 只需要icon 不需要 title 的情况
function iconChangeFn(array = [], type, ICON_OBJ) {
    array.forEach(item => {
        item.icon = ICON_OBJ[String(item[type])].icon;
    });
    return array;
}
// 需要icon 与 title 的情况
function iconTitleChange(status, move, contentIcon) {
    let value;
    if (move === 'icon') {
        value = contentIcon[String(status)].icon;
    } else {
        value = contentIcon[String(status)].title;
    }
    return value;
}

// 监测点运行状态
/**
 *
 * @param {*状态icon数组} runIconArray
 * @param {*匹配状态值} type
 * @param {*区分是icon还是鼠标hover提示} move
 */
export function CARRIER_STATUS_FN(query) {
    let value;
    for (let item of query.runIconArray) {
        if (String(query.type) === item.code) {
            value = item[query.move];
            break;
        }
    }
    return value;
}

// 设置icon&&设置title的
/**
 *
 * @param {*匹配值} type
 * @param {*区分是icon还是鼠标hover提示} move
 * @param {*icon数据源} iconData
 * @returns
 */
export function SET_ICON_TITLE_FN(type, move = 'icon', iconData) {
    return iconTitleChange(type, move, iconData);
}
// 监测点类型的icon函数 -- 针对查找回来的载体
/**
 *
 * @param {* 请求回来的数组} query
 * @param {* 匹配字段} type
 * @param {区分是icon还是鼠标hover提示} move -- 暂不需要
 */
export function CARRIER_TYPE_ICON_FN(queryArray = [], type, move = 'icon') {
    return iconChangeFn(queryArray, type, carrierIcon);
}
// 设备类型的图标函数
/**
 *
 * @param {*设备的类型区分} deviceType
 * @param {*设备匹配值} type
 * @param {区分是icon还是鼠标hover提示} move
 */
export function DEVICE_TYPE_ICON_FN(deviceType, type, move = 'icon') {
    let realDeviceIvon = deviceTypeIcon[deviceType];
    return iconTitleChange(type, move, realDeviceIvon);
}

// 提供两种方式导入
export default {
    CARRIER_STATUS_FN,
    CARRIER_TYPE_ICON_FN,
    DEVICE_TYPE_ICON_FN
};
